/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConversationCloseRequestDTO } from '../models';
// @ts-ignore
import type { ConversationDTO } from '../models';
// @ts-ignore
import type { ConversationInitRequestDTO } from '../models';
// @ts-ignore
import type { ConversationMessageDTO } from '../models';
// @ts-ignore
import type { ConversationPendingDTO } from '../models';
// @ts-ignore
import type { ConversationReadState } from '../models';
// @ts-ignore
import type { ConversationStarterDTO } from '../models';
// @ts-ignore
import type { ConversationStartersRequestDTO } from '../models';
// @ts-ignore
import type { ConversationState } from '../models';
// @ts-ignore
import type { ErrorMessage } from '../models';
// @ts-ignore
import type { PaginableGenericListResultConversationDTO } from '../models';
// @ts-ignore
import type { PaginableGenericListResultConversationHeaderDTO } from '../models';
// @ts-ignore
import type { UserType } from '../models';
/**
 * ConversationsResourceApi - axios parameter creator
 * @export
 */
export const ConversationsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Marks the conversation as closed, recording who closed it, when, and why. A closed conversation blocks new messages and is excluded from pending counts and reminders. The reason is required and must be allowed for the caller\'s role; reason OTHER also requires a note. Idempotent: closing an already-closed conversation has no effect. A manager/admin owner can later reopen it by posting a message with reopen=true, which clears the close reason.
         * @summary Close a conversation
         * @param {string} conversationId Id of the conversation to close
         * @param {ConversationCloseRequestDTO} conversationCloseRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeConversation: async (conversationId: string, conversationCloseRequestDTO: ConversationCloseRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('closeConversation', 'conversationId', conversationId)
            // verify required parameter 'conversationCloseRequestDTO' is not null or undefined
            assertParamExists('closeConversation', 'conversationCloseRequestDTO', conversationCloseRequestDTO)
            const localVarPath = `/api/v1/company/conversations/{conversationId}/close`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationCloseRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requests an Excel export of the conversations matching the given filters. The report is generated asynchronously and delivered to the requesting user as an emailed download link, so this endpoint returns immediately. The filters accepted here mirror those of the conversation list endpoint, so the export reflects whatever the dashboard is currently filtering. The export never reveals more than the dashboard: anonymous conversations do not expose the participant identity, and message bodies are omitted for conversations the caller cannot view.
         * @summary Export conversations to Excel
         * @param {UserType} [lastMessageFrom] Filter by the author type of the last message: EMPLOYEE or COMPANY_USER; omitted for any.
         * @param {string} [from] Inclusive lower bound for the conversation\&#39;s last activity, format ddMMyyyy.
         * @param {string} [to] Inclusive upper bound for the conversation\&#39;s last activity, format ddMMyyyy.
         * @param {string} [ownerId] Restrict to conversations owned by these assignees (admins only; ignored for managers). 
         * @param {string} [personEncryptedId] Restrict to conversations of a single participant, given as the person\&#39;s encrypted id.
         * @param {Set<ExportConversationsTypesEnum>} [types] Restrict to these origin types: COMMENT and/or ENGAGEMENT_STATUS; omitted for any.
         * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
         * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConversations: async (lastMessageFrom?: UserType, from?: string, to?: string, ownerId?: string, personEncryptedId?: string, types?: Set<ExportConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/conversations/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (lastMessageFrom !== undefined) {
                localVarQueryParameter['lastMessageFrom'] = lastMessageFrom;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (personEncryptedId !== undefined) {
                localVarQueryParameter['personEncryptedId'] = personEncryptedId;
            }

            if (types) {
                localVarQueryParameter['types'] = Array.from(types);
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (readState !== undefined) {
                localVarQueryParameter['readState'] = readState;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserType} [lastMessageFrom] 
         * @param {number} [fromConversation] 
         * @param {number} [toConversation] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {FindConversationsSortOrderEnum} [sortOrder] 
         * @param {Set<string>} [ownerId] 
         * @param {string} [personEncryptedId] 
         * @param {Set<FindConversationsTypesEnum>} [types] 
         * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
         * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findConversations: async (lastMessageFrom?: UserType, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindConversationsSortOrderEnum, ownerId?: Set<string>, personEncryptedId?: string, types?: Set<FindConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (lastMessageFrom !== undefined) {
                localVarQueryParameter['lastMessageFrom'] = lastMessageFrom;
            }

            if (fromConversation !== undefined) {
                localVarQueryParameter['fromConversation'] = fromConversation;
            }

            if (toConversation !== undefined) {
                localVarQueryParameter['toConversation'] = toConversation;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (ownerId) {
                localVarQueryParameter['ownerId'] = Array.from(ownerId);
            }

            if (personEncryptedId !== undefined) {
                localVarQueryParameter['personEncryptedId'] = personEncryptedId;
            }

            if (types) {
                localVarQueryParameter['types'] = Array.from(types);
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (readState !== undefined) {
                localVarQueryParameter['readState'] = readState;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} personEncryptedId 
         * @param {number} [fromConversation] 
         * @param {number} [toConversation] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {FindParticipantPreviewConversationsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findParticipantPreviewConversations: async (personEncryptedId: string, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindParticipantPreviewConversationsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personEncryptedId' is not null or undefined
            assertParamExists('findParticipantPreviewConversations', 'personEncryptedId', personEncryptedId)
            const localVarPath = `/api/v1/company/conversations/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (fromConversation !== undefined) {
                localVarQueryParameter['fromConversation'] = fromConversation;
            }

            if (toConversation !== undefined) {
                localVarQueryParameter['toConversation'] = toConversation;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (personEncryptedId !== undefined) {
                localVarQueryParameter['personEncryptedId'] = personEncryptedId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversation', 'conversationId', conversationId)
            const localVarPath = `/api/v1/company/conversations/{conversationId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get\'s conversation starters for a given context
         * @param {ConversationStartersRequestDTO} conversationStartersRequestDTO 
         * @param {number} [numSuggestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationStarters: async (conversationStartersRequestDTO: ConversationStartersRequestDTO, numSuggestions?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationStartersRequestDTO' is not null or undefined
            assertParamExists('getConversationStarters', 'conversationStartersRequestDTO', conversationStartersRequestDTO)
            const localVarPath = `/api/v1/company/conversations/starters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (numSuggestions !== undefined) {
                localVarQueryParameter['numSuggestions'] = numSuggestions;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationStartersRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingConversations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/conversations/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConversationInitRequestDTO} conversationInitRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initConversationOverStatus: async (conversationInitRequestDTO: ConversationInitRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationInitRequestDTO' is not null or undefined
            assertParamExists('initConversationOverStatus', 'conversationInitRequestDTO', conversationInitRequestDTO)
            const localVarPath = `/api/v1/company/conversations/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationInitRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Appends a message to an existing conversation. Posting to a closed conversation is rejected unless reopen=true, in which case the conversation is reopened and the message is posted in the same operation.
         * @summary Post a message to a conversation
         * @param {string} conversationId Id of the conversation to post to
         * @param {ConversationMessageDTO} conversationMessageDTO 
         * @param {boolean} [reopen] When true, reopen the conversation if it is closed before posting. Only a manager/admin owner may reopen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage: async (conversationId: string, conversationMessageDTO: ConversationMessageDTO, reopen?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('postMessage', 'conversationId', conversationId)
            // verify required parameter 'conversationMessageDTO' is not null or undefined
            assertParamExists('postMessage', 'conversationMessageDTO', conversationMessageDTO)
            const localVarPath = `/api/v1/company/conversations/message/{conversationId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (reopen !== undefined) {
                localVarQueryParameter['reopen'] = reopen;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationMessageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConversationSeen: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('setConversationSeen', 'conversationId', conversationId)
            const localVarPath = `/api/v1/company/conversations/{conversationId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationsResourceApi - functional programming interface
 * @export
 */
export const ConversationsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * Marks the conversation as closed, recording who closed it, when, and why. A closed conversation blocks new messages and is excluded from pending counts and reminders. The reason is required and must be allowed for the caller\'s role; reason OTHER also requires a note. Idempotent: closing an already-closed conversation has no effect. A manager/admin owner can later reopen it by posting a message with reopen=true, which clears the close reason.
         * @summary Close a conversation
         * @param {string} conversationId Id of the conversation to close
         * @param {ConversationCloseRequestDTO} conversationCloseRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeConversation(conversationId: string, conversationCloseRequestDTO: ConversationCloseRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeConversation(conversationId, conversationCloseRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.closeConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requests an Excel export of the conversations matching the given filters. The report is generated asynchronously and delivered to the requesting user as an emailed download link, so this endpoint returns immediately. The filters accepted here mirror those of the conversation list endpoint, so the export reflects whatever the dashboard is currently filtering. The export never reveals more than the dashboard: anonymous conversations do not expose the participant identity, and message bodies are omitted for conversations the caller cannot view.
         * @summary Export conversations to Excel
         * @param {UserType} [lastMessageFrom] Filter by the author type of the last message: EMPLOYEE or COMPANY_USER; omitted for any.
         * @param {string} [from] Inclusive lower bound for the conversation\&#39;s last activity, format ddMMyyyy.
         * @param {string} [to] Inclusive upper bound for the conversation\&#39;s last activity, format ddMMyyyy.
         * @param {string} [ownerId] Restrict to conversations owned by these assignees (admins only; ignored for managers). 
         * @param {string} [personEncryptedId] Restrict to conversations of a single participant, given as the person\&#39;s encrypted id.
         * @param {Set<ExportConversationsTypesEnum>} [types] Restrict to these origin types: COMMENT and/or ENGAGEMENT_STATUS; omitted for any.
         * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
         * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportConversations(lastMessageFrom?: UserType, from?: string, to?: string, ownerId?: string, personEncryptedId?: string, types?: Set<ExportConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportConversations(lastMessageFrom, from, to, ownerId, personEncryptedId, types, state, readState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.exportConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserType} [lastMessageFrom] 
         * @param {number} [fromConversation] 
         * @param {number} [toConversation] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {FindConversationsSortOrderEnum} [sortOrder] 
         * @param {Set<string>} [ownerId] 
         * @param {string} [personEncryptedId] 
         * @param {Set<FindConversationsTypesEnum>} [types] 
         * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
         * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findConversations(lastMessageFrom?: UserType, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindConversationsSortOrderEnum, ownerId?: Set<string>, personEncryptedId?: string, types?: Set<FindConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginableGenericListResultConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findConversations(lastMessageFrom, fromConversation, toConversation, from, to, sortOrder, ownerId, personEncryptedId, types, state, readState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.findConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} personEncryptedId 
         * @param {number} [fromConversation] 
         * @param {number} [toConversation] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {FindParticipantPreviewConversationsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findParticipantPreviewConversations(personEncryptedId: string, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindParticipantPreviewConversationsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginableGenericListResultConversationHeaderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findParticipantPreviewConversations(personEncryptedId, fromConversation, toConversation, from, to, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.findParticipantPreviewConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.getConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get\'s conversation starters for a given context
         * @param {ConversationStartersRequestDTO} conversationStartersRequestDTO 
         * @param {number} [numSuggestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationStarters(conversationStartersRequestDTO: ConversationStartersRequestDTO, numSuggestions?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationStarterDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationStarters(conversationStartersRequestDTO, numSuggestions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.getConversationStarters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingConversations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationPendingDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingConversations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.getPendingConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConversationInitRequestDTO} conversationInitRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initConversationOverStatus(conversationInitRequestDTO: ConversationInitRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initConversationOverStatus(conversationInitRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.initConversationOverStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Appends a message to an existing conversation. Posting to a closed conversation is rejected unless reopen=true, in which case the conversation is reopened and the message is posted in the same operation.
         * @summary Post a message to a conversation
         * @param {string} conversationId Id of the conversation to post to
         * @param {ConversationMessageDTO} conversationMessageDTO 
         * @param {boolean} [reopen] When true, reopen the conversation if it is closed before posting. Only a manager/admin owner may reopen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMessage(conversationId: string, conversationMessageDTO: ConversationMessageDTO, reopen?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMessage(conversationId, conversationMessageDTO, reopen, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.postMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setConversationSeen(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setConversationSeen(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsResourceApi.setConversationSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationsResourceApi - factory interface
 * @export
 */
export const ConversationsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationsResourceApiFp(configuration)
    return {
        /**
         * Marks the conversation as closed, recording who closed it, when, and why. A closed conversation blocks new messages and is excluded from pending counts and reminders. The reason is required and must be allowed for the caller\'s role; reason OTHER also requires a note. Idempotent: closing an already-closed conversation has no effect. A manager/admin owner can later reopen it by posting a message with reopen=true, which clears the close reason.
         * @summary Close a conversation
         * @param {string} conversationId Id of the conversation to close
         * @param {ConversationCloseRequestDTO} conversationCloseRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeConversation(conversationId: string, conversationCloseRequestDTO: ConversationCloseRequestDTO, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDTO> {
            return localVarFp.closeConversation(conversationId, conversationCloseRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Requests an Excel export of the conversations matching the given filters. The report is generated asynchronously and delivered to the requesting user as an emailed download link, so this endpoint returns immediately. The filters accepted here mirror those of the conversation list endpoint, so the export reflects whatever the dashboard is currently filtering. The export never reveals more than the dashboard: anonymous conversations do not expose the participant identity, and message bodies are omitted for conversations the caller cannot view.
         * @summary Export conversations to Excel
         * @param {UserType} [lastMessageFrom] Filter by the author type of the last message: EMPLOYEE or COMPANY_USER; omitted for any.
         * @param {string} [from] Inclusive lower bound for the conversation\&#39;s last activity, format ddMMyyyy.
         * @param {string} [to] Inclusive upper bound for the conversation\&#39;s last activity, format ddMMyyyy.
         * @param {string} [ownerId] Restrict to conversations owned by these assignees (admins only; ignored for managers). 
         * @param {string} [personEncryptedId] Restrict to conversations of a single participant, given as the person\&#39;s encrypted id.
         * @param {Set<ExportConversationsTypesEnum>} [types] Restrict to these origin types: COMMENT and/or ENGAGEMENT_STATUS; omitted for any.
         * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
         * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConversations(lastMessageFrom?: UserType, from?: string, to?: string, ownerId?: string, personEncryptedId?: string, types?: Set<ExportConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportConversations(lastMessageFrom, from, to, ownerId, personEncryptedId, types, state, readState, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserType} [lastMessageFrom] 
         * @param {number} [fromConversation] 
         * @param {number} [toConversation] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {FindConversationsSortOrderEnum} [sortOrder] 
         * @param {Set<string>} [ownerId] 
         * @param {string} [personEncryptedId] 
         * @param {Set<FindConversationsTypesEnum>} [types] 
         * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
         * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findConversations(lastMessageFrom?: UserType, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindConversationsSortOrderEnum, ownerId?: Set<string>, personEncryptedId?: string, types?: Set<FindConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options?: RawAxiosRequestConfig): AxiosPromise<PaginableGenericListResultConversationDTO> {
            return localVarFp.findConversations(lastMessageFrom, fromConversation, toConversation, from, to, sortOrder, ownerId, personEncryptedId, types, state, readState, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} personEncryptedId 
         * @param {number} [fromConversation] 
         * @param {number} [toConversation] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {FindParticipantPreviewConversationsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findParticipantPreviewConversations(personEncryptedId: string, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindParticipantPreviewConversationsSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<PaginableGenericListResultConversationHeaderDTO> {
            return localVarFp.findParticipantPreviewConversations(personEncryptedId, fromConversation, toConversation, from, to, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(conversationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDTO> {
            return localVarFp.getConversation(conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get\'s conversation starters for a given context
         * @param {ConversationStartersRequestDTO} conversationStartersRequestDTO 
         * @param {number} [numSuggestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationStarters(conversationStartersRequestDTO: ConversationStartersRequestDTO, numSuggestions?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationStarterDTO>> {
            return localVarFp.getConversationStarters(conversationStartersRequestDTO, numSuggestions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingConversations(options?: RawAxiosRequestConfig): AxiosPromise<ConversationPendingDTO> {
            return localVarFp.getPendingConversations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConversationInitRequestDTO} conversationInitRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initConversationOverStatus(conversationInitRequestDTO: ConversationInitRequestDTO, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDTO> {
            return localVarFp.initConversationOverStatus(conversationInitRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Appends a message to an existing conversation. Posting to a closed conversation is rejected unless reopen=true, in which case the conversation is reopened and the message is posted in the same operation.
         * @summary Post a message to a conversation
         * @param {string} conversationId Id of the conversation to post to
         * @param {ConversationMessageDTO} conversationMessageDTO 
         * @param {boolean} [reopen] When true, reopen the conversation if it is closed before posting. Only a manager/admin owner may reopen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage(conversationId: string, conversationMessageDTO: ConversationMessageDTO, reopen?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDTO> {
            return localVarFp.postMessage(conversationId, conversationMessageDTO, reopen, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConversationSeen(conversationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDTO> {
            return localVarFp.setConversationSeen(conversationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConversationsResourceApi - object-oriented interface
 * @export
 * @class ConversationsResourceApi
 * @extends {BaseAPI}
 */
export class ConversationsResourceApi extends BaseAPI {
    /**
     * Marks the conversation as closed, recording who closed it, when, and why. A closed conversation blocks new messages and is excluded from pending counts and reminders. The reason is required and must be allowed for the caller\'s role; reason OTHER also requires a note. Idempotent: closing an already-closed conversation has no effect. A manager/admin owner can later reopen it by posting a message with reopen=true, which clears the close reason.
     * @summary Close a conversation
     * @param {string} conversationId Id of the conversation to close
     * @param {ConversationCloseRequestDTO} conversationCloseRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public closeConversation(conversationId: string, conversationCloseRequestDTO: ConversationCloseRequestDTO, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).closeConversation(conversationId, conversationCloseRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requests an Excel export of the conversations matching the given filters. The report is generated asynchronously and delivered to the requesting user as an emailed download link, so this endpoint returns immediately. The filters accepted here mirror those of the conversation list endpoint, so the export reflects whatever the dashboard is currently filtering. The export never reveals more than the dashboard: anonymous conversations do not expose the participant identity, and message bodies are omitted for conversations the caller cannot view.
     * @summary Export conversations to Excel
     * @param {UserType} [lastMessageFrom] Filter by the author type of the last message: EMPLOYEE or COMPANY_USER; omitted for any.
     * @param {string} [from] Inclusive lower bound for the conversation\&#39;s last activity, format ddMMyyyy.
     * @param {string} [to] Inclusive upper bound for the conversation\&#39;s last activity, format ddMMyyyy.
     * @param {string} [ownerId] Restrict to conversations owned by these assignees (admins only; ignored for managers). 
     * @param {string} [personEncryptedId] Restrict to conversations of a single participant, given as the person\&#39;s encrypted id.
     * @param {Set<ExportConversationsTypesEnum>} [types] Restrict to these origin types: COMMENT and/or ENGAGEMENT_STATUS; omitted for any.
     * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
     * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public exportConversations(lastMessageFrom?: UserType, from?: string, to?: string, ownerId?: string, personEncryptedId?: string, types?: Set<ExportConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).exportConversations(lastMessageFrom, from, to, ownerId, personEncryptedId, types, state, readState, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserType} [lastMessageFrom] 
     * @param {number} [fromConversation] 
     * @param {number} [toConversation] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {FindConversationsSortOrderEnum} [sortOrder] 
     * @param {Set<string>} [ownerId] 
     * @param {string} [personEncryptedId] 
     * @param {Set<FindConversationsTypesEnum>} [types] 
     * @param {ConversationState} [state] Filter by lifecycle state: OPEN, CLOSED, or omitted for both.
     * @param {ConversationReadState} [readState] Filter by read state from the requesting dashboard user\&#39;s point of view: READ, UNREAD, or omitted for both.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public findConversations(lastMessageFrom?: UserType, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindConversationsSortOrderEnum, ownerId?: Set<string>, personEncryptedId?: string, types?: Set<FindConversationsTypesEnum>, state?: ConversationState, readState?: ConversationReadState, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).findConversations(lastMessageFrom, fromConversation, toConversation, from, to, sortOrder, ownerId, personEncryptedId, types, state, readState, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} personEncryptedId 
     * @param {number} [fromConversation] 
     * @param {number} [toConversation] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {FindParticipantPreviewConversationsSortOrderEnum} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public findParticipantPreviewConversations(personEncryptedId: string, fromConversation?: number, toConversation?: number, from?: string, to?: string, sortOrder?: FindParticipantPreviewConversationsSortOrderEnum, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).findParticipantPreviewConversations(personEncryptedId, fromConversation, toConversation, from, to, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} conversationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public getConversation(conversationId: string, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).getConversation(conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get\'s conversation starters for a given context
     * @param {ConversationStartersRequestDTO} conversationStartersRequestDTO 
     * @param {number} [numSuggestions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public getConversationStarters(conversationStartersRequestDTO: ConversationStartersRequestDTO, numSuggestions?: number, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).getConversationStarters(conversationStartersRequestDTO, numSuggestions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public getPendingConversations(options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).getPendingConversations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConversationInitRequestDTO} conversationInitRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public initConversationOverStatus(conversationInitRequestDTO: ConversationInitRequestDTO, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).initConversationOverStatus(conversationInitRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Appends a message to an existing conversation. Posting to a closed conversation is rejected unless reopen=true, in which case the conversation is reopened and the message is posted in the same operation.
     * @summary Post a message to a conversation
     * @param {string} conversationId Id of the conversation to post to
     * @param {ConversationMessageDTO} conversationMessageDTO 
     * @param {boolean} [reopen] When true, reopen the conversation if it is closed before posting. Only a manager/admin owner may reopen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public postMessage(conversationId: string, conversationMessageDTO: ConversationMessageDTO, reopen?: boolean, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).postMessage(conversationId, conversationMessageDTO, reopen, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} conversationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsResourceApi
     */
    public setConversationSeen(conversationId: string, options?: RawAxiosRequestConfig) {
        return ConversationsResourceApiFp(this.configuration).setConversationSeen(conversationId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportConversationsTypesEnum = {
    Comment: 'COMMENT',
    EngagementStatus: 'ENGAGEMENT_STATUS'
} as const;
export type ExportConversationsTypesEnum = typeof ExportConversationsTypesEnum[keyof typeof ExportConversationsTypesEnum];
/**
 * @export
 */
export const FindConversationsSortOrderEnum = {
    Recent: 'RECENT',
    Older: 'OLDER'
} as const;
export type FindConversationsSortOrderEnum = typeof FindConversationsSortOrderEnum[keyof typeof FindConversationsSortOrderEnum];
/**
 * @export
 */
export const FindConversationsTypesEnum = {
    Comment: 'COMMENT',
    EngagementStatus: 'ENGAGEMENT_STATUS'
} as const;
export type FindConversationsTypesEnum = typeof FindConversationsTypesEnum[keyof typeof FindConversationsTypesEnum];
/**
 * @export
 */
export const FindParticipantPreviewConversationsSortOrderEnum = {
    Recent: 'RECENT',
    Older: 'OLDER'
} as const;
export type FindParticipantPreviewConversationsSortOrderEnum = typeof FindParticipantPreviewConversationsSortOrderEnum[keyof typeof FindParticipantPreviewConversationsSortOrderEnum];
